import { format, isSameYear, isValid, parseISO, subMonths } from 'date-fns';
import { ja } from 'date-fns/locale';

export const DATE_FORMAT_DEFAULT = 'yyyy/MM/dd HH:mm';
export const DATE_FORMAT_SHORT = 'yyyy-MM-dd';
export const DATE_FORMAT_LONG = 'yyyy-MM-dd HH:mm:ss';
export const DATE_FORMAT_SLASH_SHORT = 'yyyy/MM/dd';
export const DATE_FORMAT_SLASH_LONG = 'yyyy/MM/dd HH:mm:ss';
export const DATE_FORMAT_JP_SHORT = 'yyyy年MM月dd日';
export const DATE_FORMAT_JP_LONG = 'yyyy年MM月dd日 HH:mm:ss';
export const DATE_FORMAT_JP_LONG_HM = 'yyyy年MM月dd日 HH:mm';
export const DATE_FORMAT_JP_LONG_WEEKDAY = 'yyyy年MM月dd日(E) HH:mm:ss';
export const DATE_FORMAT_DATETIME_LOCAL = "yyyy-MM-dd'T'HH:mm";
export const DATE_FORMAT_WITHOUT_YEAR = 'MM/dd HH:mm';

export type DateFormat =
  | typeof DATE_FORMAT_DEFAULT
  | typeof DATE_FORMAT_SHORT
  | typeof DATE_FORMAT_LONG
  | typeof DATE_FORMAT_SLASH_SHORT
  | typeof DATE_FORMAT_SLASH_LONG
  | typeof DATE_FORMAT_JP_SHORT
  | typeof DATE_FORMAT_JP_LONG
  | typeof DATE_FORMAT_JP_LONG_HM
  | typeof DATE_FORMAT_JP_LONG_WEEKDAY
  | typeof DATE_FORMAT_DATETIME_LOCAL
  | typeof DATE_FORMAT_WITHOUT_YEAR;

export function formatDate(
  value: Date | string | number | null | undefined,
  dateFormat = DATE_FORMAT_DEFAULT,
  locale = ja
) {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const date =
    typeof value === 'string'
      ? parseISO(value)
      : typeof value === 'number'
      ? new Date(value)
      : new Date(value.getTime());

  return isValid(date)
    ? format(date, dateFormat, { locale })
    : typeof value === 'string'
    ? value
    : '';
}

export function isSameDateWithYear(
  value: Date | string | number | null | undefined,
  reference: Date | string | number | null | undefined
): boolean {
  if (
    value === undefined ||
    value === null ||
    value === '' ||
    reference === undefined ||
    reference === null ||
    reference === ''
  ) {
    return false;
  }

  const valueDate =
    typeof value === 'string'
      ? parseISO(value)
      : typeof value === 'number'
      ? new Date(value)
      : value;

  const referenceDate =
    typeof reference === 'string'
      ? parseISO(reference)
      : typeof reference === 'number'
      ? new Date(reference)
      : reference;

  return isSameYear(valueDate, referenceDate);
}

/**
 * 日付が指定した月数より過去かどうかを判定する
 */
export const isPastDateByMonths = (date: Date, months: number): boolean => {
  return date < subMonths(new Date(), months);
};
